import { Outlet, Link, useLocation } from "react-router-dom";
import "../components/landingPages/footer-distributed-with-address-and-phones.css";
import './PublicLayout.css';
import GirlPowerFooter from "./landingPages/girlPower/Footer";
import ShowStarsFooter from "./landingPages/showStars/Footer";

const Navbar = () => {
  const location = useLocation();
  const fromState = location.state?.from || "";
  const faviconEnv = process.env.REACT_APP_FAVICON || '';

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={faviconEnv} alt="Logo" />
        </Link>
      </div>
      <div className="navbar-links">
        <Link to="/login" state={{ from: fromState }}>Login</Link>
        <Link to="/register" state={{ from: fromState }}>Registro</Link>
        <Link to="/plans">Planes</Link>
      </div>
    </nav>
  );
};

const PublicLayout = () => {
  const hostname = window.location.hostname;
    
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      {/* Header */}
      <header style={{zIndex: 1}}>
        <Navbar />
      </header>

      {/* Main Content */}
      <main className="flex-grow-1">
        <Outlet /> {/* Renders the child routes */}
      </main>

      {(hostname === 'localhost' || hostname.includes('girlpower.com.co') || hostname.includes('patinajenextgeneration.com')) && 
        <GirlPowerFooter />
      }
      {(hostname.includes('showstars.com.co')) && 
        <ShowStarsFooter />
      }
    </div>
  );
};

export default PublicLayout;
